import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import coverSecondaryImage from '@assets/images/enrollment-secundary-background.jpg';
import { MediaContainer } from '@components';
const COVER_IMAGE = 'https://100ladrillos-assets.s3.us-east-1.amazonaws.com/webp/banner-enrolamiento.webp';
const COVER_IMAGE_POSITION = 'center 72%';
const DefaultMediaContainer = () => {
    const { pathname } = useLocation();
    const isSecondaryImage = /summary/g.test(pathname);
    const backgroundImage = isSecondaryImage ? coverSecondaryImage : COVER_IMAGE;
    return (_jsx(MediaContainer, { backgroundImage: backgroundImage, backgroundPosition: isSecondaryImage ? 'center' : COVER_IMAGE_POSITION }));
};
export default DefaultMediaContainer;
